import GithubSvg from './img/github.svg';
import { LegacyIcon } from './LegacyIcon';
import type { LegacyIconProps } from './types';

export const Github = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="github" className={className} size={size} {...props}>
    <GithubSvg />
  </LegacyIcon>
);
